import { GridSeparatorContainer } from './styles';
import { Inset } from '@doordash/design-language';
import PropTypes from 'prop-types';
import React from 'react';
import Separator from '@doordash/component-separator';

var GridSeparator = function GridSeparator(_ref) {
  var isSquished = _ref.isSquished,
      insetSize = _ref.insetSize,
      type = _ref.type,
      middleColumn = _ref.middleColumn,
      shouldInsetStartAtTitle = _ref.shouldInsetStartAtTitle;
  var gridColumnStart = type === Separator.Types.InsetBorder && shouldInsetStartAtTitle ? middleColumn : 1;
  return /*#__PURE__*/React.createElement(GridSeparatorContainer, {
    gridColumnStart: gridColumnStart,
    type: type,
    isSquished: isSquished,
    insetSize: insetSize
  }, /*#__PURE__*/React.createElement(Separator, {
    type: type === Separator.Types.InsetBorder ? Separator.Types.FullBorder : type
  }));
};

GridSeparator.propTypes = {
  isSquished: PropTypes.bool.isRequired,
  insetSize: PropTypes.oneOf(Object.values(Inset.Sizes)).isRequired,
  type: Separator.propTypes.type,
  middleColumn: PropTypes.number.isRequired,
  shouldInsetStartAtTitle: PropTypes.bool.isRequired
};
export default GridSeparator;